import { CustomModal } from '../CustomModal';
import { Btn } from '../ui';

type InspectionDiscardModalProps = {
    visible: boolean;
    onDismiss: () => void;
    onStartOver: () => void;
    onExit: () => void;
    flowKind?: 'inspection' | 'dailyService';
};

export const InspectionDiscardModal = ({
    visible,
    onDismiss,
    onStartOver,
    onExit,
    flowKind = 'inspection',
}: InspectionDiscardModalProps) => {
    const isDailyService = flowKind === 'dailyService';
    const flowNoun = isDailyService ? 'Daily Service' : 'inspection';

    return (
        <CustomModal
            visible={visible}
            onDismiss={onDismiss}
            header={`Discard ${flowNoun} progress?`}
            footer={
                <div className="modal-footer-actions inspect-flow-discard-modal-footer">
                    <Btn
                        variant="secondary-soft-outlined"
                        buttonText={`Continue ${flowNoun}`}
                        buttonOnClick={onDismiss}
                    />
                    <Btn variant="warning-outlined" buttonText="Start over" buttonOnClick={onStartOver} />
                    <Btn variant="warning" buttonText="Discard & exit" buttonOnClick={onExit} />
                </div>
            }
        >
            <p>
                Your answers, notes, and attachments for this {flowNoun} will be cleared. This cannot be
                undone.
            </p>
        </CustomModal>
    );
};
